"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ServiceRegistryService = void 0;
const errors_1 = require("../errors");
class ServiceRegistryService {
    constructor(serviceRegistry) {
        this.serviceRegistry = serviceRegistry;
    }
    /**
     * @param service The service to register
     * @returns A promise that resolves when the service is registered
     */
    async registerService(service) {
        try {
            console.log(`Registering service: ${service.name}`);
            const tx = await this.serviceRegistry.registerService(service.name, service.category, service.description);
            console.log(`Transaction sent for service ${service.name}: ${tx.hash}`);
            const receipt = await tx.wait();
            console.log(`Transaction confirmed for service ${service.name}: ${receipt?.hash}`);
            return true;
        }
        catch (error) {
            console.error(`Error registering service ${service.name}:`, error);
            if (error.reason === "Service already registered") {
                throw new errors_1.ServiceAlreadyRegisteredError(service.name);
            }
            throw error;
        }
    }
    /**
     * Gets a service by name.
     * @param {string} name - The name of the service.
     * @returns {Promise<Service>} A promise that resolves to the service.
     */
    async getService(name) {
        const service = await this.serviceRegistry.getService(name);
        return service;
    }
}
exports.ServiceRegistryService = ServiceRegistryService;
